import React, { useState, useEffect } from 'react';
import {
  Checkbox, IconClose, IconMiniminize, Link,
} from 'gatorcomponents';
import * as Styles from './SettingsPopover.styles';
import { localStorageKeys } from '@/enums/storage/storage.enum';
import { MAIA_PRIVACY_POLICY, MAIA_TERMS_OF_USE } from '@/config/urls/supportUrls';
import { ATIVACAO_OPEN_CHAT_ON_LOGIN } from '@/config/GrowthBook/constants';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import useLocale from '@/hooks/useLocale';
import { useResize } from '@/hooks/useResize';

const { showMaiaOnInit } = localStorageKeys;
const SettingsPopover = ({
  label,
  onClose,
  isFullScreen,
  privacyPolicy,
  termsOfUse,
  isSideContent,
  handleBackToSideContent,
}) => {
  const { aichat: aichatLocale } = useLocale();
  const savedValue = localStorage.getItem(showMaiaOnInit) === 'true' || localStorage.getItem(showMaiaOnInit) === null;
  const canOpenChatOnLogin = useFeatureIsOn(ATIVACAO_OPEN_CHAT_ON_LOGIN);
  const windowRect = useResize();
  const { width } = windowRect;
  const isMobile = width < 600;

  const [checked, setChecked] = useState(savedValue);
  const handleSetChecked = () => setChecked(!checked);

  useEffect(() => {
    if (checked) {
      localStorage.setItem(showMaiaOnInit, 'true');
    } else {
      localStorage.setItem(showMaiaOnInit, 'false');
    }
  }, [checked]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('#chat-settings-popover')) {
        onClose();
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [onClose]);

  return (
    <Styles.Wrapper $isFullScreen={isFullScreen} data-testid="SettingsPopover" id="chat-settings-popover">
      {isSideContent && (
        <>
          <Styles.GroupTitle>{aichatLocale.popover.groupOptions}</Styles.GroupTitle>
          <Styles.BoldButton onClick={onClose}>
            <IconClose size="md" color="lowDark" />
            {aichatLocale.popover.close}
          </Styles.BoldButton>
          {!isMobile && (
            <Styles.BoldButton $top="10px" onClick={handleBackToSideContent}>
              <IconMiniminize size="md" color="lowDark" />
              {aichatLocale.popover.sidebar}
            </Styles.BoldButton>
          )}
          <Styles.Divider />
        </>
      )}

      {canOpenChatOnLogin && (
        <>
          <Styles.GroupTitle>{aichatLocale.popover.groupSettings}</Styles.GroupTitle>
          <Styles.CheckboxWrapper htmlFor="checkDontShowAgain" onClick={handleSetChecked} data-testid="SettingsPopoverCheckbox">
            <Checkbox checked={checked} id="checkDontShowAgain" />
            <Styles.CheckboxDescription onClick={handleSetChecked}>
              {label}
            </Styles.CheckboxDescription>
          </Styles.CheckboxWrapper>
          <Styles.Divider />
        </>
      )}

      <Styles.GroupTitle>{aichatLocale.popover.groupUseful}</Styles.GroupTitle>
      <Styles.LinkWrapper>
        <Link text={privacyPolicy} href={MAIA_PRIVACY_POLICY} />
      </Styles.LinkWrapper>

      <Styles.LinkWrapper>
        <Link text={termsOfUse} href={MAIA_TERMS_OF_USE} />
      </Styles.LinkWrapper>
    </Styles.Wrapper>
  );
};


export default SettingsPopover;
